
<div class="crud-rows-panel">
  <form [formGroup]="form">
    <div class="crud-rows-table-section">
      <div class="crud-rows-table-wrapper mat-table-wrapper">
        <mat-table formArrayName="formRows" #table [dataSource]="sortDataSource" matSort class="crud-rows-table"
                         [matSortActive]="defaultSort" [matSortDirection]="defaultSortDirection" matSortDisableClear 
                         cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
                         (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="id">
            <mat-header-cell [crud-column-header]="columns.column('id')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.id">
                Id 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="id" id="id.{{index}}"              
              [ngModel]="element.id" #id              
              type="number" placeholder="Id"              
              disabled>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="asset">
            <mat-header-cell [crud-column-header]="columns.column('asset')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.asset">
                Asset 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <mat-select formControlName="asset" id="asset.{{index}}"              
              [ngModel]="element.asset" #asset              
              placeholder="Asset" [disabled]="true"              
              [compareWith]="assetCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let asset of assetSelectionList" [value]="asset">
              {{assetDisplay(asset)}}
            </mat-option>
          </mat-select>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="assetId">
            <mat-header-cell [crud-column-header]="columns.column('assetId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.assetId">
                Asset Id 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="assetId" id="assetId.{{index}}"              
              (ngModelChange)="assetIdRowChanging($event, element, index)" [(ngModel)]="element.assetId"              
              (ngModelChange)="assetIdRowChanged($event, element, index)" #assetId              
              type="number" placeholder="Asset Id">
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.comments">
                Comments 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="comments" id="comments.{{index}}"              
              (ngModelChange)="commentsRowChanging($event, element, index)" [(ngModel)]="element.comments"              
              (ngModelChange)="commentsRowChanged($event, element, index)" #comments              
              maxlength="1000" placeholder="Comments">
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.createdBy">
                Created By 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="createdBy" id="createdBy.{{index}}"              
              (ngModelChange)="createdByRowChanging($event, element, index)" [(ngModel)]="element.createdBy"              
              (ngModelChange)="createdByRowChanged($event, element, index)" #createdBy              
              maxlength="255" placeholder="Created By">
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.createdDate">
                Created Date 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="createdDate" id="createdDate.{{index}}"              
              (ngModelChange)="createdDateRowChanging($event, element, index)" [(ngModel)]="element.createdDate"              
              (ngModelChange)="createdDateRowChanged($event, element, index)" #createdDate              
              [matDatepicker]="createdDateDatePicker" placeholder="Created Date">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="lockingVersion">
            <mat-header-cell [crud-column-header]="columns.column('lockingVersion')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.lockingVersion">
                Locking Version 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="lockingVersion" id="lockingVersion.{{index}}"              
              (ngModelChange)="lockingVersionRowChanging($event, element, index)" [(ngModel)]="element.lockingVersion"              
              (ngModelChange)="lockingVersionRowChanged($event, element, index)" #lockingVersion              
              type="number" placeholder="Locking Version">
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="maintenanceBy">
            <mat-header-cell [crud-column-header]="columns.column('maintenanceBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.maintenanceBy">
                Maintenance By 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="maintenanceBy" id="maintenanceBy.{{index}}"              
              (ngModelChange)="maintenanceByRowChanging($event, element, index)" [(ngModel)]="element.maintenanceBy"              
              (ngModelChange)="maintenanceByRowChanged($event, element, index)" #maintenanceBy              
              maxlength="255" placeholder="Maintenance By">
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="maintenanceDate">
            <mat-header-cell [crud-column-header]="columns.column('maintenanceDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.maintenanceDate">
                Maintenance Date 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="maintenanceDate" id="maintenanceDate.{{index}}"              
              (ngModelChange)="maintenanceDateRowChanging($event, element, index)" [(ngModel)]="element.maintenanceDate"              
              (ngModelChange)="maintenanceDateRowChanged($event, element, index)" #maintenanceDate              
              [matDatepicker]="maintenanceDateDatePicker" placeholder="Maintenance Date">
          <mat-datepicker-toggle matSuffix [for]="maintenanceDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #maintenanceDateDatePicker color="primary"></mat-datepicker>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="maintenanceType">
            <mat-header-cell [crud-column-header]="columns.column('maintenanceType')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AssetMaintenance.maintenanceType">
                Maintenance Type 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <mat-select formControlName="maintenanceType" id="maintenanceType.{{index}}"              
              (ngModelChange)="maintenanceTypeRowChanging($event, element, index)" [(ngModel)]="element.maintenanceType"              
              (ngModelChange)="maintenanceTypeRowChanged($event, element, index)" #maintenanceType              
              placeholder="Maintenance Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let maintenanceType of maintenanceTypeSelectionList" [value]="maintenanceType.code">
              {{maintenanceType.meaning}}
            </mat-option>
          </mat-select>
            </mat-cell>
          </ng-container>  

  
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="search-column-verysmall">
              <div class="header-title" i18n="@@common.select">Select</div>
            </mat-header-cell>
            <mat-cell [ngClass]="{'row-selected': rowSelected(element)}" class="search-column-verysmall"
              *matCellDef="let element; let index = index">
              <button type="button" mat-raised-button color="accent" (click)="selectRow(element)"
                [disabled]="selectDisabled(element)" *ngIf="rowsSelectedByButton && !rowSelected(element)" 
                class="action-button">Select</button>
              <button type="button" mat-raised-button color="primary" *ngIf="rowsSelectedByButton && rowSelected(element)" 
                class="action-button">Selected</button>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>
      
          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions search-column-verysmall mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions search-column-verysmall mat-elevation-z9">
             
              <button type="button" *ngIf="allowsDeleteRows()" [disabled]="!isDeleteEnabled(element)" mat-raised-button
                color="accent" (click)="deleteRow(element)">Delete</button>
             
            </mat-cell>
          </ng-container>
  
          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; let i = index; columns: columns.displayedColumns;" class="search-table"
            (click)="rowClicked(row)" [ngClass]="rowClass(row)"></mat-row>
  
        </mat-table>
      </div>
      <!--
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>
      -->
    </div>
  </form>
</div>